import { HeaderSide } from "./headerside"
import style from './style.module.css'
import { MapWithPoligons } from "../../MapWithPoligons";
import L from "leaflet";
import { Table } from "./Table";
import { Graph1 } from "./graph1";
import { Graph2 } from "./graph2";

const customMarkerIcon = L.icon({
    iconUrl: "/imort.svg",
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });


export const Processingcapacities = () => {
   
    const staticMarker = [
        {
            latitude: 42.8746,
            longitude: 74.5698,
            name: "ОсОО «Кыргыз Мясопродукт»",
            popupContent: `
              <div style="font-family: Montserrat, Arial, sans-serif; max-width: 320px;">
                <div style="font-size: 20px; font-weight: 600; margin-bottom: 12px;">Карточка Переработчика</div>
                <div style="margin-bottom: 8px;"><b>Название компании:</b> ОсОО «Кыргыз Мясопродукт»</div>
                <div style="margin-bottom: 8px;"><b>Адрес:</b> Чуйская область, Аламудунский район, с. Сары-Ой, ул. Заводская, 20</div>
                <div style="margin-bottom: 8px;"><b>Статус:</b> <span style="color: #1B7F1B; font-weight: 500;">Активен</span></div>
                <hr style="margin: 10px 0;">
                <div style="margin-bottom: 8px;"><b>ИНН:</b> 123456789001234</div>
                <div style="margin-bottom: 8px;"><b>Форма собственности:</b> Частная</div>
                <hr style="margin: 10px 0;">
                <div style="margin-bottom: 8px;"><b>Контактное лицо:</b> Айдарбек уулу Сапар</div>
                <div style="margin-bottom: 8px;"><b>Телефон:</b> +996 312 555555</div>
                <div style="margin-bottom: 8px;"><b>Email:</b> kurgusutprod@xampie.com</div>
              </div>
            `
          }
    ];
    return (
        <div >
        <HeaderSide />
        <div className={style.container}>
            <div className={style.map}>
            <div className={style.content}>
                <MapWithPoligons
                     extraData={staticMarker}
                              latitude={41.5089324}
                              longitude={74.724091}
                              customIcon={customMarkerIcon}
                              type = {["REGION", "AREA", "CITY_OF_REPUBLICAN_SIGNIFICANCE"]}
                />
            </div>
            <div className={style.table}>
                <Table />
            </div>
            </div>
        </div>
        <div className={style.graphs}>
        <div className={style.graph1}>
            <Graph1 />
        </div>
        <div className={style.graph2}>
            <Graph2 />
        </div>
        </div>
        </div>
    )
}